module.exports = __webpack_public_path__ + "static/img/training.a4a843d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/training.png
// module id = W4Lz
// module chunks = 0